export * from './detail';
export * from './summary';
export * from './beneficiary.i';
export * from './outgoing.transfer.i';
export * from './transfer.history.i';
export * from './transfer.attachment';
export * from './check-addresses-response';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/transfer/index.ts